import React from 'react';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import errorgif from "../assets/error.gif";
import onephoto from "../assets/1.png";
import twophoto from "../assets/2.png";
import threephoto from "../assets/3.png"; 

const Styles = styled.div`   

`;

const Unsuccessful = () => {
    const { t } = useTranslation(); // LANGUAGE

    return (
        <Styles>
            {/* === STEP SECTION ==== */}
            <div className="step-section animate__animated animate__fadeIn animate__delay-800ms">
                <div className="container">

                    <div className="row step-bg">
                        <div className="card col background-green cardsize mx-2">
                            <div className="card-body mobile-card-size">
                                <h5 className="card-title">
                                    {/* STEP */}
                                    {t('text.1')}
                                </h5>
                                <img className="card-img-top" src={onephoto} alt="step 1" />
                            </div>
                        </div>
                        <div className="card col background-green cardsize mx-2">
                            <div className="card-body mobile-card-size">
                                <h5 className="card-title">
                                    {/* STEP */}
                                    {t('text.1')}
                                </h5>
                                <img className="card-img-top" src={twophoto} alt="step 2" />
                            </div>
                        </div>
                        <div className="card col background-red cardsize mx-2">
                            <div className="card-body mobile-card-size">
                                <h5 className="card-title">
                                    {/* STEP */}
                                    {t('text.1')}
                                </h5>
                                <img className="card-img-top" src={threephoto} alt="step 3" />
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            {/* === END STEP SECTION ==== */}


            <div className="content-section mobile-content-section">
                <div className="container">

                    <div className="container animate__animated animate__fadeIn">
                        <div className="row justify-content-center error-message">
                            <h3>
                                {/* Registration Unsuccessful!  */}
                                {t('text.47')}
                            </h3>
                        </div>
                        <div className="row justify-content-center">
                            <div className="icon-box">
                                <img src={errorgif} alt="error" height="100" width="100" className="rounded-circle" />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="container">
                                <center><b>
                                    <p>
                                        {/* There's already an existing record. Please check with the administrator about this.  */}
                                        {t('text.48')}
                                    </p>
                                </b></center>
                            </div>
                        </div>
                    </div>


                    <hr className="animate__animated animate__bounceIn animate__delay-1s" />

                    <div className="content-top">
                        <h5 className="content-top-header animate__animated animate__fadeInLeft animate__delay-500ms">
                            {/* IMPORTANT REMINDER  */}
                            {t('text.34')}
                        </h5>
                        <p className="animate__animated animate__fadeInUp">
                            {/* Before visiting CPF, please take note of the following to ensure smooth access at the gantries  */}
                            {t('text.35')}
                        </p>
                        <ol className="list-decimal animate__animated animate__fadeInUp">
                            <li>
                                {/* Visitors are required to bring along one of the following identification cards for scanning at the gantries: */}
                                {t('text.36')}
                            </li>
                            <ul>
                                <li>
                                    {/* NRIC/FIN  */}
                                    {t('text.37')}
                                </li>
                                <li>
                                    {/* Driving Licence  */}
                                    {t('text.38')}
                                </li>
                                <li>
                                    {/* Student/Senior Citizen EZ-link card  */}
                                    {t('text.39')}
                                </li>
                                <li>
                                    {/* Employment pass  */}
                                    {t('text.40')}
                                </li>
                                <li>
                                    {/* S-pass  */}
                                    {t('text.41')}
                                </li>
                                <li>
                                    {/* Work Permit pass  */}
                                    {t('text.42')}
                                </li>
                            </ul>
                            <li>
                                {/* Visitors without any identification card may approach the Visitor Registration Counter at Level 1 Lift Lobbies to obtain a registration pass for entry. */}
                                {t('text.43')}
                            </li>
                            <li>
                                {/* When the visiting slots are full, the next visitor will receive an SMS notification once the next slot is available. */}
                                {t('text.44')}
                            </li>
                            <li>
                                {/* All information provided will be kept confidential and used solely for the purpose of visitation and contact tracing, if needed */}
                                {t('text.45')}
                            </li>
                        </ol>
                    </div>


                    <br />
                    <div className="row animate__animated animate__fadeInUp animate__delay-1s">
                        <div className="container">
                            {/* <Button className="btn btn-primary col-md-4 offset-md-4" type="primary" href="/">OK</Button> */}
                            <Button className="btn btn-primary col-md-2 col-sm-12" type="primary" href="/">
                                {/* OK */}
                                {t('text.46')} 
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </Styles>
    );
};

export default Unsuccessful;